<kodit-dropdown
  (optionChanged)="handleOnItemChange($event)"
  [formCtrlId]="formCtrlId"
  [formCtrl]="formCtrl!"
  [options]="items"
  [ctrlDisabled]="shouldDisable"
></kodit-dropdown>
